import { Selector } from 'react-redux';

import { StoreState } from '~/reducer';
import { myWorkspaceStoreStateSelector } from '~/selectors';

import { LayoutStoreState } from './layoutSlice';

export const myWorkspaceLayoutStoreStateSelector: Selector<
  StoreState,
  LayoutStoreState
> = (state) => myWorkspaceStoreStateSelector(state).layout;
